import { Theme } from "../../Theme";

export const cardStyle = {
  display: "block",
  width: "20em",
  transitionDuration: "0.3s",
  height: "15em",
  backgroundColor: Theme.primaryBody,
  cursor:"pointer",
  //   backgroundColor: "transparent",
  //   boxShadow: "none",
};

export const cardContant = {
  // backgroundColor: Theme.primaryBody,
  color: Theme.white,
};

export const cardTitle = {
  display: "block",
  fontFamily: "'Roboto', sans-serif",
  fontWeight: "600",
};

export const cardSubtitle = {
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: "200",
};
